import React, { useState } from "react";
import DeckLoader from "./DeckLoader";
import AllSentencesList from "./AllSentencesList";

export default function DeckView() {
  const [deckName, setDeckName] = useState("bengali");

  return (
    <>
      <label>Select Deck: </label>
      <select onChange={(e) => setDeckName(e.target.value)} value={deckName}>
        <option value="bengali">Bengali</option>
        <option value="anatomy">Anatomy</option>
      </select>
      <DeckLoader deckName={deckName} />
    </>
  );
}
